export default {
  getFormsSettings: (state) => state.formsSettings,
  getForms: (state) => state.forms,
  getFormsCredentials: (state) => state.formsCredentials,
  getApplicationForm: (state) => state.applicationForm,
  getMinMaxOccupancyValidation: (state) => state.isMinMaxOccupancyValid,
  getApplicationFormSections: (state) => state.sections,
  getApplicationFormLang: (state) => state.language,
};
